import { Component } from '@angular/core';
import { SidebarComponent } from '../../../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../../../components/mobile-header/mobile-header.component';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../../environments/environment';
import { FooterComponent } from '../../../../components/footer/footer.component';
@Component({
  selector: 'app-validacion-linkedin',
  standalone: true,
  imports: [SidebarComponent, MobileHeaderComponent, MatButtonModule, FooterComponent],
  templateUrl: './validacion-linkedin.component.html',
  styleUrl: './validacion-linkedin.component.scss'
})
export class ValidacionLinkedinComponent {

  linkedinUrlManual = environment.linkedinUrlManual;
  
  constructor(private router: Router) {

    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll to the top
    });

  }

  validateLinkedin(useLinkedin: boolean) {
    window.location.href = this.linkedinUrlManual; // Replace with the actual URL to navigate to
  }

}
